















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import TableActions from "@/components/form/TableActions.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";

@Component({
  components: {
    CustomDatepicker,
    CustomButton,
    TableActions,
    CustomTableCol,
    CustomTableItem,
    CustomTable
  }
})
export default class CourseRegistrationsTableItem extends Vue {
  @Prop() student!: any;
  @Prop() isLoading!: boolean;
  @Prop() checked!: boolean;
  isCheck: boolean = false;

  data() {
    return {
      status: undefined
    };
  }

  changeCheckBox() {
    this.$emit("check", this.student);
  }

  @Watch("checked")
  checkChecked() {
    this.isCheck = this.checked;
  }
}
